export class MultipleError {
    requestId: number;
    errorDescription: string;

    constructor(requestId: number, errorDescription: string) {
        this.requestId = requestId;
        this.errorDescription = errorDescription;
    }
}